import dateTimeMixins from "./dateTimeMixins"
export default {
    mixins: [dateTimeMixins],
    data() {
        return {
            selectedOfficer: null,
            selectedRole: null,
            selectedType: null,
            selectedRange: null,
        }
    },
    props: {
        officers: {
            type: Array,
            default: () => [],
        },
        roles: {
            type: Array,
            default: () => [],
        },
        orders: {
            type: Array,
            default: () => [],
        },
        orderTypes: {
            type: Array,
            default: () => [],
        },
    },
    filters: {
        setOptions(arr) {
            return arr.map(({ id, name }) => ({
                value: id,
                text: name,
            }))
        },
    },
    computed: {
        lastSixMonths() {
            const startDate = new Date()
            let month = startDate.getMonth()
            let year = startDate.getFullYear()
            const resp = [{ month, year }]
            for (let i = 0; i < 6; i++) {
                month--
                if (month === -1) {
                    year--
                    month = 11
                }
                resp.unshift({ month, year })
            }
            return resp
        },

        monthNames() {
            return [
                this.$translate('jan'),
                this.$translate('feb'),
                this.$translate('mar'),
                this.$translate('apr'),
                this.$translate('may'),
                this.$translate('jun'),
                this.$translate('jul'),
                this.$translate('aug'),
                this.$translate('sep'),
                this.$translate('oct'),
                this.$translate('nov'),
                this.$translate('dec'),
            ]
        },

        filteredOrders() {
            const $this = this
            return this.orders.map(x => {
                x.completedTime = null;
                x.scheduleTime = null;
                x.duration_hours = null;
               
                const created_date = this.getDateObject(x.created_at);
                x.createdTime = created_date.getTime();

                x.created_month = created_date.getMonth();
                x.created_year = created_date.getFullYear();

                if (x.schedule_at) {
                    const schedule_date = this.getDateObject(x.schedule_at);
                    x.scheduleTime = schedule_date.getTime();
                }

                if (x.completed_at) {
                    const completed_date = this.getDateObject(x.completed_at);
                    x.completedTime = completed_date.getTime();
                    x.duration_hours = (completed_date.getTime() - created_date.getTime()) / (1000 * 60 * 60);
                }

                return x
            }).filter(
                x =>
                    $this.filterType(x.order_type_id, $this.selectedType) &&
                    $this.filterOfficer(
                        x.officer_id,
                        $this.selectedOfficer,
                        $this.selectedRole
                    ) &&
                    $this.filterRange(x.createdTime, $this.selectedRange)
            )
        },

        OfficerOptions() {
            const _officers = []
            for (let officer of this.officers || []) {
                if (this.isOfficerInRole(officer, this.selectedRole)) {
                    _officers.push({
                        value: officer.id,
                        text: officer.name,
                    })
                }
            }
            return _officers
        },

        rolesOptions() {
            console.log("roles", this.roles)
            return this.roles.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },

        orderTypesOptions() {
            return this.orderTypes && this.orderTypes[0] && this.orderTypes[0].map(x => ({
                value: x.id,
                text: x.name,
            }))
        },
    },
    methods: {
        isOfficerInRole(officer, selectedRole) {
            return !selectedRole || officer.roles.some(x => x === selectedRole)
        },

        filterType(order_type_id, selectedType) {
            return !selectedType || order_type_id === selectedType
        },
        filterOfficer(officer_id, selectedOfficer, selectedRole) {
            if (!selectedOfficer && !selectedRole) return true
            else if (selectedOfficer) return selectedOfficer == officer_id
            return this.OfficerOptions.some(x => x.value === officer_id)
        },
        filterRange(createdTime, selectedRange) {
            if (!selectedRange || (!selectedRange.to && !selectedRange.from))
                return true
            const fromTime = new Date(selectedRange.from).getTime()
            const toTime = new Date(selectedRange.to).getTime()
            return createdTime >= fromTime && createdTime <= toTime
        },
    },
}
